import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'
import {IBanners} from './getLeaderboardBanner'

export const getLeaderboardBannerDetail = async (id: string): Promise<ApiRes<IBanners>> => {
    return await apiGet(API_URL, `admin/banner/${id}`)
}
